<template>
  <div class="box p-l-2 p-r-2 p-t-0 p-b-0 m-b-2 m-t-2 m-r-5">
    <div class="is-flex is-align-items-center p-0">
      <UserAvatar class="m-t-0 mx-1" :user="user" size="25" />
      <div class="is-size-5">{{ user.name }}</div>
      <div class="close mx-1">
        <span @click.stop="onRemove" class="has-text-weight-semibold is-size-2">&times;</span>
      </div>
    </div>
  </div>
</template>

<script>
import UserAvatar from '/@/modules/user/components/presentational/UserAvatar.vue';
import { User } from '/@/modules/user/models/User';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'UserSelectTag',
  emits: ['remove'],
  components: { UserAvatar },
  props: {
    user: {
      type: User,
      required: true
    }
  },
  methods: {
    onRemove() {
      this.$emit('remove');
    }
  }
};
</script>

<style scoped>
.box {
  display: inline-block !important;
}

.close {
  z-index: var(--ce-z-index-10000);
}
</style>
